// Konfigurasi untuk sistem maintenance
export const maintenanceConfig = {
  // Error types yang akan memicu maintenance page
  fatalErrorTypes: [
    'ChunkLoadError',
    'Loading chunk',
    'Network Error',
    'Module not found',
    'Cannot resolve module'
  ],
  
  // Info context yang akan memicu maintenance page
  fatalContexts: [
    'render function',
    'component render',
    'template compilation'
  ],
  
  // Routes yang dikecualikan dari maintenance redirect
  excludedRoutes: [
    '/maintenance',
    '/',
    '/privacy-policy-intranet'
  ],
  
  // Component names yang dikecualikan dari error boundary
  excludedComponents: [
    'MaintenanceView',
    'ErrorBoundary',
    'RoleSelector',
    'RoleDisplay',
    'ElButton',
    'ElDialog'
  ],
  
  // Delay sebelum redirect ke maintenance (ms)
  redirectDelay: 3000,
  
  // Enable/disable maintenance system
  enabled: true,
  
  // Debug mode untuk logging
  debug: false
}

// Helper function untuk check apakah error adalah fatal
export function isFatalError(err, info = '') {
  if (!maintenanceConfig.enabled) return false
  
  const errorMessage = err.message || err.toString()
  const errorName = err.name || ''
  
  // Check error types
  const hasFatalType = maintenanceConfig.fatalErrorTypes.some(type => 
    errorMessage.includes(type) || errorName.includes(type)
  )
  
  // Check context info
  const hasFatalContext = maintenanceConfig.fatalContexts.some(context => 
    info.includes(context)
  )
  
  if (maintenanceConfig.debug) {
    console.log('Error check:', {
      error: errorMessage,
      info,
      hasFatalType,
      hasFatalContext,
      isFatal: hasFatalType || hasFatalContext
    })
  }
  
  return hasFatalType || hasFatalContext
}

// Helper function untuk check apakah route dikecualikan
export function isExcludedRoute(path) {
  return maintenanceConfig.excludedRoutes.includes(path)
}

// Helper function untuk check apakah component dikecualikan
export function isExcludedComponent(componentName) {
  if (!componentName) return false
  
  return maintenanceConfig.excludedComponents.some(excluded => 
    componentName.includes(excluded)
  )
}